import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    height: '40rem',
    width: '100%',
    position: 'relative',
  },
  rowToggle: {
    color: 'gray',
    position: 'absolute',
    right: '0',
    zIndex: '1',
    textTransform: 'uppercase',
    background: 'rgb(255,255,255,0.5)',
    paddingLeft: '1rem',
    width: '150px',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
